// ---------------------------------------------------------------------------
// WeekKpis — five roll-up tiles for the visible week. The "Missed" and
// "Offline" tiles are clickable and toggle the matching grid filter.
// ---------------------------------------------------------------------------
import React from "react";
import {perDayStats, weekStats} from "../utils/bellStatusUtils";

function WeekKpis({data, i18n, onJump}) {
    const {t, num, lang} = i18n;
    const k = weekStats(data);
    const perDay = perDayStats(data);
    const workingDays = (data.days || []).filter((d) => !d.holiday).length;

    const spark = perDay.map((p, idx) => {
        const h = p.pct === null ? 6 : Math.max(6, Math.round(p.pct * 22));
        const col =
            p.pct === null ? "var(--line)" : p.pct > 0.95 ? "var(--emerald)" : p.pct > 0.8 ? "var(--gold)" : "var(--fail)";
        return <i key={idx} style={{height: `${h}px`, background: col}} />;
    });

    const tiles = [
        {
            c: "k-sched", l: t("scheduled"), v: num(k.scheduled),
            d: `${num((data.periods || []).length)} × ${num(workingDays)} ${t("days")}`,
        },
        {
            c: "k-played", l: t("playedK"), v: num(k.played + k.late),
            d: k.late ? `${num(k.played)} ${t("onTime")} · ${num(k.late)}${t("late2")}` : t("allOnTime"),
        },
        {
            c: "k-fail", l: t("failedK"), v: num(k.failed),
            d: k.failed ? (k.failed === 1 ? t("fail1") : t("failN")) : t("noFail"), f: "failed",
        },
        {
            c: "k-off", l: t("offlineK"), v: num(k.offline),
            d: k.offline ? t("ctrlDown") : "—", f: "offline",
        },
        {
            c: "k-rate", l: t("rate"), v: k.rate === null ? "—" : num(k.rate) + "%",
            d: t("ofWeek"), spark: true,
        },
    ];

    return (
        <section className="kpis">
            {tiles.map((x) => (
                <div
                    key={x.c}
                    className={`kpi ${x.c} ${x.f ? "clickable" : ""}`}
                    onClick={x.f ? () => onJump(x.f) : undefined}
                    role={x.f ? "button" : undefined}
                    tabIndex={x.f ? 0 : undefined}
                    onKeyDown={x.f ? (e) => (e.key === "Enter" || e.key === " ") && onJump(x.f) : undefined}
                >
                    <div className="kl">{x.l}</div>
                    <div className="kv">{x.v}</div>
                    <div className="kd">{x.d}</div>
                    {x.spark ? <div className="spark">{spark}</div> : null}
                </div>
            ))}
        </section>
    );
}

export default WeekKpis;
